import { getMediaTypes } from '@kvass/media-types'
import Store from '@/store'

const WalkableTemplates = ['custom-malling-1']

export default function getMediaTypesFromTemplate(template) {
  const { MediaTypes, NuxtPages, NuxtProjects } = Store.state.enums
  if ([...NuxtPages, ...NuxtProjects, ...WalkableTemplates].includes(template)) return getMediaTypes(MediaTypes)
  return getMediaTypes(MediaTypes.filter(type => type !== 'Walkable'))
}
